// Risk regime classification for currencies that the COT table tracks.
// Risk-ON pairs typically rally when risk appetite is high.
// Risk-OFF pairs typically rally during stress.
export const RISK_ON = new Set(["EUR", "GBP", "AUD", "CAD", "NZD"]);
export const RISK_OFF = new Set(["JPY", "CHF", "DXY"]);

/**
 * Returns:
 *  'aligned'      -> positioning confirms a risk-off move
 *  'contra'       -> positioning opposes risk-off
 *  null           -> not classified (e.g. yields, VIX itself)
 */
export function riskOffAlignment(symbol, changeNetNoncomm) {
  if (RISK_ON.has(symbol)) {
    if (changeNetNoncomm < 0) return "aligned";
    if (changeNetNoncomm > 0) return "contra";
  }
  if (RISK_OFF.has(symbol)) {
    if (changeNetNoncomm > 0) return "aligned";
    if (changeNetNoncomm < 0) return "contra";
  }
  return null;
}
